import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import logo from '../logo.png';
import heroImage from '../home1.jpg';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div className="home-page">
        <section className="home-hero" style={{ backgroundImage: `url(${heroImage})` }}>
          <div className="home-hero-overlay" />
          <div className="home-hero-content">
            <img src={logo} alt="Mozo Logistics" className="home-brand-logo" />
            <p className="home-brand-name">Mozo</p>
            <h1 className="home-headline">Move inventory without the spreadsheet chaos</h1>
            <p className="home-support">
              Schedule vehicle moves, assign drivers, and keep every delivery visible — from the lot to the customer.
            </p>
            <div className="home-cta-group">
              <a className="home-btn home-btn-primary" href="mailto:info@mozologistics.com">
                Contact us
              </a>
              <Link className="home-btn home-btn-secondary" to="/login">
                Log in
              </Link>
            </div>
          </div>
        </section>

        <section className="home-section home-how">
          <div className="home-section-inner">
            <h2 className="home-section-title">How it works</h2>
            <p className="home-section-lead">Three steps from request to delivery — no phone trees, no paper trail.</p>
            <ol className="home-steps">
              <li className="home-step">
                <span className="home-step-num" aria-hidden="true">1</span>
                <div>
                  <h3>Create a transport request</h3>
                  <p>Enter the vehicle, pickup, and delivery details in a guided flow your staff can learn in minutes.</p>
                </div>
              </li>
              <li className="home-step">
                <span className="home-step-num" aria-hidden="true">2</span>
                <div>
                  <h3>Assign a driver</h3>
                  <p>Match available drivers to the job and notify them on mobile when the schedule is ready.</p>
                </div>
              </li>
              <li className="home-step">
                <span className="home-step-num" aria-hidden="true">3</span>
                <div>
                  <h3>Track the delivery</h3>
                  <p>See active moves in one place — distance, timing, and status without chasing updates by phone.</p>
                </div>
              </li>
            </ol>
          </div>
        </section>

        <section className="home-section home-outcomes">
          <div className="home-section-inner">
            <h2 className="home-section-title">Built for dealerships</h2>
            <p className="home-section-lead">Clear costs, paperless records, and drivers who stay in sync.</p>
            <ul className="home-outcomes-list">
              <li>
                <i className="pi pi-file" aria-hidden="true" />
                <span>Paperless trip records</span>
              </li>
              <li>
                <i className="pi pi-mobile" aria-hidden="true" />
                <span>Driver mobile app</span>
              </li>
              <li>
                <i className="pi pi-chart-line" aria-hidden="true" />
                <span>Transparent cost calculation</span>
              </li>
            </ul>
          </div>
        </section>

        <section className="home-cta-band">
          <div className="home-section-inner home-cta-band-inner">
            <div>
              <h2 className="home-cta-band-title">Ready to modernize inventory transport?</h2>
              <p className="home-cta-band-text">Talk with Mozo about fitting your dealership workflow.</p>
            </div>
            <a className="home-btn home-btn-primary" href="mailto:info@mozologistics.com">
              Contact us
            </a>
          </div>
        </section>
      </div>
    );
  }
}
